<template>
  <div class="promo-item" :style="gradient" @click.stop="openDescription">
    <div class="promo-item__header">
      <div class="promo-item__badge">{{ getLocale(promo.promotionTypeProps.title) }}</div>
    </div>
    <div class="promo-item__img">
      <u-i-compressed-image :compressed-images="images" :alt="getLocale(promo.title)" />
    </div>
    <div class="promo-item__body">
      <div class="promo-item__title" v-html="getLocale(promo.title)"></div>
      <div class="promo-item__desc" v-html="getLocale(promo.description)"></div>
    </div>
    <div class="promo-item__footer">
      <ol-button color="gray-night-100" size="sm" :label="getLocale(promo.button)" @click.stop="goToLink" />
      <i
        v-if="promo.additionalDescription?.ru"
        class="las la-question-circle text-white size_24 cursor-pointer"
        @click.stop="openDescription"
      />
    </div>
  </div>
</template>

<script>
import UICompressedImage from 'components/ui/UICompressedImage.vue'
import { externalLinkMessageToApp } from 'src/common/webview'
import { OlButton } from '@gamesite/olimp-core'

export default {
  name: 'ThePromoItem',
  components: {
    OlButton,
    UICompressedImage,
  },
  inject: ['appModal'],
  props: {
    promo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    image() {
      const id = this.getLocale(this.promo.image)

      return this.promo.images.find((i) => i.id == id)
    },
    images() {
      return {
        xl: this.image?.compressedImage?.webp.xl,
      }
    },
    lang() {
      return this.$i18n.locale
    },
    outerLink() {
      const link = this.promo?.buttonAction ?? ''
      return link.startsWith('http')
    },
    // promoDate() {
    //   if (this.promo.dateStart && this.promo.dateEnd) {
    //     return `${new Date(this.promo.dateStart).toLocaleDateString('ru-RU')} - ${new Date(
    //       this.promo.dateEnd
    //     ).toLocaleDateString('ru-RU')}`
    //   }
    //   return false
    // },
    gradient() {
      if (!this.promo.promotionTypeProps) {
        return ''
      }
      const colorTo = this.promo.promotionTypeProps.color_to
      const colorFrom = this.promo.promotionTypeProps.color_from
      if (!colorFrom || !colorTo) {
        return ''
      }
      return `background: linear-gradient(42.17deg, ${colorFrom} -5.7%, ${colorTo} 111.08%)`
    },
  },
  methods: {
    openDescription() {
      const actions = [
        {
          label: this.getLocale(this.promo.button),
          action: this.goToLink,
        },
      ]
      this.appModal.open({
        title: this.getLocale(this.promo.title),
        bodyHtml: this.getLocale(this.promo.additionalDescription),
        actions,
        isBigSize: true,
        class: 'promo',
      })
    },
    goToLink() {
      if (this.$store.getters.isWebView && this.outerLink) {
        externalLinkMessageToApp(this.promo.buttonAction)
        return
      }
      this.outerLink
        ? window.open(this.promo.buttonAction, '_blank')
        : this.$router.push(this.promo.buttonAction).catch(() => {})
    },
    getLocale(locale) {
      if (!locale) {
        return
      }

      let result = locale[this.lang] ? locale[this.lang] : locale['ru']

      if (typeof result == 'string') {
        const variables = result.match(/(-?\d+(\.\d+)?)/g)?.map((v) => +v)

        if (variables) {
          variables.forEach((num) => {
            if (num.toString().length > 4) {
              const newVariable = num
                .toLocaleString('ru-RU')
                .replace(/,/g, '.')
                .replaceAll(/\u00A0/g, '&nbsp')

              result = result.replaceAll(num.toString(), newVariable)
            }
          })
        }
      }
      return result
    },
  },
}
</script>

<style lang="scss">
.promo-item {
  border-radius: 10px;
  overflow: hidden;
  background: linear-gradient(42.17deg, rgb(0, 79, 252) -5.7%, rgb(200, 0, 19) 111.08%);

  &__header {
    background-color: rgba(#fff, 0.28);
    height: 40px;
    text-transform: uppercase;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 24px;
    flex: none;
  }

  &__badge {
    font-size: 16px;
    font-weight: 500;
  }

  &__dates {
    font-size: 14px;
    font-weight: 400;
    margin-left: auto;
  }

  &__img {
    width: 100%;
  }

  &__img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    flex: none;
    aspect-ratio: 15 / 13;
  }

  &__body {
    padding: 16px 24px;
    color: #fff;
    height: 120px;
    flex: none;
  }

  &__title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 500;
    margin-bottom: 8px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  &__desc {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  &__footer {
    padding: 0 24px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }
}
</style>
